import { APIService } from '../api/APIService';

export class ProductsService {
    path: string;
    apiService: APIService;

    constructor(apiService: APIService) {
        const productURI = import.meta.env.VITE_DS_PRODUCT_API;
        if (!productURI) {
            throw new Error('No product api uri path set');
        }
        this.path = productURI;
        this.apiService = apiService;
    }

    getProducts(productIds?: string[]): Promise<endpoints.ProductDTO[]> {
        const params = productIds ? { id: productIds.join() } : undefined;
        return this.apiService.getData(this.path, params);
    }
}
